import * as React from "react";

export interface PrevStepProps {
  goToPrevStep: React.EventHandler<any>;
}

const PrevStep = (props: PrevStepProps) => (
  <button className="wizard-footer__prev-step" onClick={props.goToPrevStep}>
    <i className="fa wizard-footer__nav-icon fa-caret-left" />
  </button>
);

export default PrevStep;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/PrevStep.tsx